import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import Section from '../components/ui/Section';

const Video = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Section id="video" variant="dark" withFlyingElements={false}>
      <motion.div
        initial={{ opacity: 0, y: 30, filter: 'blur(10px)' }}
        whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-5xl mx-auto"
      >
        {/* Glowing border wrapper */}
        <div 
          className="relative w-full rounded-lg p-[2px]"
          style={{ 
            background: 'linear-gradient(135deg, rgba(203, 163, 90, 0.6), rgba(203, 163, 90, 0.3))',
            boxShadow: '0 0 20px rgba(203, 163, 90, 0.5), 0 0 40px rgba(203, 163, 90, 0.3), 0 0 60px rgba(203, 163, 90, 0.1)',
          }}
        >
          {/* Inner container with dark background */}
          <div 
            className="relative w-full rounded-lg overflow-hidden bg-black"
            style={{ 
              paddingBottom: '56.25%',
            }}
          >
            <iframe
              title="vimeo-player"
              src="https://player.vimeo.com/video/1147564513?h=1114d7ed59&title=0&byline=0&portrait=0&dnt=1&transparent=0&autopause=0&autoplay=0"
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              frameBorder="0"
              referrerPolicy="strict-origin-when-cross-origin"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              allowFullScreen
              style={{
                border: 'none',
              }}
            />
          </div>
        </div>
      </motion.div>
    </Section>
  );
};

export default Video;

